"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var nav_1 = require("../../../common/helpers/nav");
function StudentSidebarNavigationController(UserService, UsersModel, VueStoreFactory, $q) {
    var vm = this;
    vm.currentUser = UserService.getCurrentUser();
    vm.userHasBalance = false;
    vm.allowSchedulingWithBalance = true;
    $q.all([
        UsersModel.getStudentBalance(vm.currentUser.id),
        UsersModel.getStudentByID(vm.currentUser.id),
    ]).then(function (responses) {
        if (responses[0].balance > 0) {
            vm.unpaidBalance = responses[0].balance;
            vm.userHasBalance = true;
        }
        vm.canAddPickupLocations =
            responses[1].school.allows_custom_pickup_locations;
        vm.studentCanSchedule = true;
        vm.studentCanScheduleWithBalance = true;
        var drivePolicy = VueStoreFactory.state.auth.policies.policies.find(function (policy) {
            return policy.name === "drives";
        });
        var allowStudentToScheduleMeta = drivePolicy.policymeta.find(function (meta) {
            return meta.meta_key === "allow_students_to_schedule";
        });
        if (allowStudentToScheduleMeta) {
            vm.studentCanSchedule = allowStudentToScheduleMeta.meta_value;
        }
        var allowStudentToScheduleWithBalanceMeta = drivePolicy.policymeta.find(function (meta) {
            return meta.meta_key === "allow_students_with_balances_to_schedule";
        });
        if (allowStudentToScheduleWithBalanceMeta) {
            vm.allowSchedulingWithBalance =
                allowStudentToScheduleWithBalanceMeta.meta_value === "Y";
        }
        vm.showWaitList = false;
        var schedulingPolicy = VueStoreFactory.state.auth.policies.policies.find(function (policy) { return policy.name === "scheduling"; });
        if (schedulingPolicy) {
            var enableWaitList = schedulingPolicy.policymeta.find(function (meta) { return meta.meta_key === "enable_wait_list"; });
            var allowStudents = schedulingPolicy.policymeta.find(function (meta) { return meta.meta_key === "allow_students_to_join_wait_list"; });
            vm.showWaitList =
                (enableWaitList === null || enableWaitList === void 0 ? void 0 : enableWaitList.meta_value) === "Y" &&
                    (allowStudents === null || allowStudents === void 0 ? void 0 : allowStudents.meta_value) === "Y";
        }
    });
    (0, nav_1.nav)();
}
StudentSidebarNavigationController.$inject = [
    "UserService",
    "UsersModel",
    "VueStoreFactory",
    "$q",
];
exports.default = StudentSidebarNavigationController;
